import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import flatten from "lodash/flatten";
import unionBy from "lodash/unionBy";
import {Creators, Types} from "../reducer";
import { normalizeEmail } from "../../common/normalize";

import * as firebase from "firebase";

export default action$ =>
    action$.ofType(Types.SEARCH_CUSTOMER).switchMap(
        action =>
            new Promise((resolve, reject) => {
                const searchFields = action.searchFields &&
                action.searchFields.length > 0
                    ? action.searchFields
                    : ["phone", "email"];

                // search by each key
                const searchPromises = searchFields.map(
                    searchField => {
                        // email is stored lowercase; phone is stored as
                        // digits stripped of punctuation, matching what
                        // the user is expected to type here.
                        const keyword =
                            searchField === "email"
                                ? normalizeEmail(action.keyword)
                                : action.keyword;

                        return new Promise((searchResolve, searchReject) => {
                            firebase
                                .database()
                                .ref("customers")
                                .orderByChild(searchField)
                                .startAt(keyword)
                                .limitToFirst(10)
                                .once("value")
                                .then(snapshot => {
                                    const results = [];
                                    snapshot.forEach(childSnapshot => {
                                        // as firebase returned unmatched items so we do a clientside filter
                                        const found = {
                                            ...childSnapshot.val(),
                                            key: childSnapshot.key
                                        };
                                        if (found[searchField].indexOf(keyword) !== -1) {
                                            results.push(found);
                                        }
                                    });
                                    searchResolve(results);
                                })
                                .catch(error => {
                                    searchReject(error);
                                });
                        });
                    }
                );

                // combine
                Promise.all(searchPromises)
                    .then(results => {
                        // keep the `key` for UI identity need
                        const revisedResult = unionBy(flatten(results), "key");
                        resolve(Creators.searchCustomerSucceeded(revisedResult));
                    })
                    .catch(() => reject(Creators.searchCustomerSucceeded([])));
            })
    );



// WEBPACK FOOTER //
// ./src/customer/epics/searchCustomer.js